define([
    'text!index2021-crest-line/component/page-content.html',
    'index2021-crest-line/common/api',
    'jquery',
    '../common/utils',
    'index2021-base-line/component/swiper-title',
    'index2021-base-line/component/product-list',

    'css!index2021-crest-line/component/page-content.css'
], function(
    tpl,
    Api,
    $,Utils,
    SwiperTitle,
    ProductList
){
    return {
        components: {
            SwiperTitle: SwiperTitle,
            ProductList: ProductList
        },
        template: tpl,
        data: function(){
            return {
                isPC: true,
                crestTitle: 's20480_1630304757_7269.png',
                crestCon: 's20480_1630296742_1928.png',
                crestType: 's20480_1630297438_4011.png',
                crestMaterial: [
                    {img:'s20480_1630304159_9392.png',name: '晚霞红',info: '天然大理石，红线米黄抛光后晶莹剔透，又具流畅自然的石肌纹理.'},
                    {img:'s20480_1630304177_4065.png',name: '白洞石',info: '具有浓郁的文化和历史韵味，地质变化形成的孔洞积蓄自然力量.'},
                    {img:'s20480_1630304188_6001.png',name: '红洞石',info: '洞石因表面布满孔洞而得名，红洞石中红、黄、粉等多重颜色相间，质朴富有细节.'}
                ],
                crestWood: [
                    {img:'s20480_1630315306_3608.png',imgPhone:'s20480_1630376731_6412.png',woodImg:'s20480_1630305451_2178.png',woodImgPhone:'s20480_1630377230_3698.png',name:'考拉灰',info:'打破木材传统色调,叠加呈现出透着木头本色的哑光高级质感.'},
                    {img:'s20480_1630305475_8093.png',imgPhone:'s20480_1630377657_4979.png',woodImg:'s20480_1630305496_4185.png',woodImgPhone:'s20480_1630377681_8243.png',name:'新骏马黑',info:'黑随木纹疏密松散变化，如水墨般浓淡相间.'}
                ],
                crestVideo: [
                    {name:'设计山脊',nameEn:'crest on design',info1:'写意的东方美',info2:'在四平八稳、虚实相间与市井玩物中',img:'s20480_1630309434_6619.png',video:'http://1257018232.vod2.myqcloud.com/c75973e1vodcq1257018232/72fb58445285890793376287499/ARC7XQjd9qkA.mp4'},
                    {name:'工艺山脊',nameEn:'crest on craftmanship',info1:'极致的制作工艺',info2:'实现建筑式的设计美感',img:'s20480_1630310053_6724.png',video:''},
                    {name:'现代山脊',nameEn:'crest on modernism',info1:'',info2:'',img:'s20480_1630311677_1827.png',video:'http://1257018232.vod2.myqcloud.com/c75973e1vodcq1257018232/853cd7db5285890793335979190/P6TdaL7bHgsA.mp4'}
                ],
                crestTitlePhone: 's20480_1630313047_3712.png',
                crestConPhone: 's20480_1630313629_6370.png',
                crestTypePhone: 's20480_1630314470_2715.png',
                crestWidth: 0,
                crestHeight: 0,
                crestConWidth: 0,
                crestWoodWidth: 0,
                productList: [],
                ridgeNum: 16,
                productWidth: 0
            };
        },
        methods: {
            init: function(){
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                    $('.fixed-menu').css({display: 'none'});
                }else {
                    obj.isPC = true;
                }
                obj.getWidth();
                obj.getImages();
            },
            getWidth: function () {
                var obj = this;
                if(obj.isPC){
                    obj.productWidth = ($(window).width()-150)/4;
                    obj.crestConWidth = $(window).width()*94/100;
                    obj.crestWidth = obj.crestConWidth*600/1440;
                    obj.crestHeight = obj.crestWidth/600*752;
                    obj.crestWoodWidth = $(window).width()/1440*250;
                }else {
                    obj.productWidth = 320;
                }
            },
            getImages: function () {
                var _this = this;
                Api.highListApi.ajax()
                    .done(function(data){
                        _this.productList = data.high;
                    });
            }
        },
        mounted: function(){
            this.init();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                obj.getWidth();
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-crest-line/component/page-content.js
// module id = 246
// module chunks = 10